import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/designer-poshmark';

export default function Example() {
  return (
    <>
      <Head>
        <title>Poshmark Tip: Where To Source and How To Sell Designers</title>
        <meta
          name='description'
          content='When you visit online marketplaces, you will notice one type of item that sells well: designers. No matter the category, branded products almost always draw the attention of shoppers. Potential buyers purchase the name of the item, along with the company’s values, characteristics, and the quality they integrate into their products.'
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/designer-poshmark' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/designer-poshmark' />
        <meta property='og:title' content='Poshmark Tip: Where To Source and How To Sell Designers' />
        <meta
          property='og:description'
          content='When you visit online marketplaces, you will notice one type of item that sells well: designers. No matter the category, branded products almost always draw the attention of shoppers. Potential buyers purchase the name of the item, along with the company’s values, characteristics, and the quality they integrate into their products.'
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=4' />
        <meta property='article:published_time' content='2022-01-22T00:00:00.000Z' />
        <meta property='article:modified_time' content='2022-01-22T00:00:00.000Z' />
        <meta property='article:tag' content='Poshmark' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
